import React from 'react';
import { createPortal } from 'react-dom';
import './ExistingPolicyModal.css';

interface ExistingPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
  coverageEndDate?: string | null;
  coverageStartDate?: string | null;
}

const ExistingPolicyModal: React.FC<ExistingPolicyModalProps> = ({
  isOpen,
  onClose,
  coverageEndDate,
  coverageStartDate
}) => {
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleOkayClick = () => {
    onClose();
  };

  console.log('🔍 ExistingPolicyModal: Render called with props:', { isOpen, coverageEndDate });
  
  if (!isOpen) {
    console.log('❌ ExistingPolicyModal: Not rendering - isOpen is false');
    return null;
  }

  console.log('✅ ExistingPolicyModal: Rendering modal - isOpen is true');

  const modalContent = (
    <div className="existing-policy-modal-backdrop" onClick={handleBackdropClick}>
      <div className="existing-policy-modal-container">
        <div className="existing-policy-modal-content">
          <div className="existing-policy-modal-card">
            {/* Modal Header */}
            <div className="existing-policy-modal-header">
              <h2 className="existing-policy-modal-title">Ooops!</h2>
              <button
                className="existing-policy-modal-close"
                onClick={onClose}
                aria-label="Close modal"
              >
                ×
              </button>
            </div>

            {/* Modal Body */}
            <div className="existing-policy-modal-body">
              <div className="existing-policy-modal-message">
                <p>
                  It seems like you just bought Travel Insurance that already covers some of these
                  dates{` [${coverageStartDate} and ${coverageEndDate} of existing policy]`}.
                </p>
                
                <p>
                  Please double check your coverage period, as you cannot purchase insurance
                  with overlapping dates. For more info and assistance, please e-mail{' '}
                  <a
                    href="mailto:travelonline@pacificcross.com.ph"
                    className="existing-policy-modal-email-link"
                  >
                    travelonline@pacificcross.com.ph
                  </a>
                </p>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="existing-policy-modal-footer">
              <button
                className="existing-policy-modal-okay-btn"
                onClick={handleOkayClick}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // Render modal using React portal to ensure it's rendered at document body level
  return createPortal(modalContent, document.body);
};

export default ExistingPolicyModal;